import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationPathConstants } from '@ddt-web/config';
import { Config } from '@ddt-web/store-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigurationPropertiesService } from '../app-configuration-properties.interface';
import { AppConfigService } from '../services/app-config.service';

@Injectable({ providedIn: 'root' })
export class ConfigRouteGuardService implements CanActivate {
	public storeConfig: Config<any>;
	public appName: string;

	constructor(@Inject(AppConfigurationPropertiesService) private properties,
		public appConfigService: AppConfigService, private router: Router) {
		this.storeConfig = this.properties.store.appConfig;
		this.appName = this.properties.appName;
	}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.appConfigService.hasTool(this.storeConfig, this.appName).pipe(map(isToolEnabled => {
			if (isToolEnabled) {
				return true;
			}

			this.router.navigate([ApplicationPathConstants.ERROR_PAGE_PATH], { queryParams: { errorType: 'app-config' } });
			return false;
		}));
	}
}
